import React, {useEffect} from 'react';

function Licensing (props) {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    return (
      <>
      <div id="page-banner" className="origin container-fluid py-5 position-relative">
          <div className="container">
          <div className="row py-5">
              <div className="col text-white text-center py-5">
                  <h1 className="mt-5 text-uppercase">Licensing</h1>
                  <h2 className="fs-3 mt-4">Power Your Own Link-Sharing Tech.</h2>
              </div>
          </div>
          </div>
      <div className="overlay"></div>
      </div>


      <section className="panel bg-white">
      <div className="container py-5 h-100">

          <div className="row h-100">
              <div className="col-md-7 col-lg-6 mx-auto text-center">
                  <p className="fs-4">License the technology behind LINKOLN for your own platform or product.</p>
                  <div className="rounded-3 bg-dark border border-3 text-center mb-4 shadow p-4 px-2 text-light">
                        <h3>CALL</h3>
                        <p className="fs-4"><a href="tel:312-651-6626" className="text-success fw-bold">312-651-6626</a></p>
                        <hr className="mx-5"/>
                        <h3>EMAIL</h3>
                        <p className="fs-4"><a href="mailto:licensing@scoutware.com" className="text-success fw-bold">licensing@scoutware.com</a></p>
                  </div>
                  <div className="row">
                    <div className="col text-end border-end pb-0">
                        <h4 className="fs-2">SCOUTWARE</h4>
                        <p className="mb-0"><a href="https://scoutware.com" target="_blank" rel="noreferrer" >scoutware.com</a></p>
                    </div>
                    <div className="col text-start">
                        <h4 className="fs-2">LINKOLN</h4>
                        <p className="mb-0"><a href="https://linkoln.io" target="_blank" rel="noreferrer" >linkoln.io</a></p>
                        </div>

                  </div>
              </div>
              
          </div>

      </div>
      </section>



      </>
    );
}

export default Licensing;
